import { iconStyle } from "./styles";

export const PURPLE_DOT_TEST_ID = "purple-dot-icon";

export default function PurpleDotIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      style={iconStyle}
      data-testid={PURPLE_DOT_TEST_ID}
    >
      <g style={{ mixBlendMode: "multiply" }}>
        <circle cx="9" cy="9" r="8.5" fill="#AE5FCB" fillOpacity="0.15" />
        <circle cx="9" cy="9" r="8.5" stroke="white" />
      </g>
      <circle cx="9" cy="9" r="4" fill="#AE5FCB" />
    </svg>
  );
}
